import { cn } from "../../utils/common/cn";
import React from "react";

interface StatusBadgeProps {
  status: "Low" | "Medium" | "High" | "Completed" | "Planned" | "Frozen";
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const getStatusStyles = () => {
    switch (status) {
      case "Low":
      case "Completed":
        return "status-low";
      case "Medium":
      case "Planned":
        return "status-medium";
      case "High":
        return "status-high";
      case "Frozen":
        return "bg-primary/20 text-primary";
      default:
        return "bg-muted text-muted-foreground";
    }
  };

  return (
    <span className={cn("status-badge", getStatusStyles(), className)}>
      {status}
    </span>
  );
}
